const ItemRelationshipType = {
  KIT_PARENT: 'KIT_PARENT',
  KIT_CHILD: 'KIT_CHILD',
  PURCHASE_AS: 'PURCHASE_AS',
  SELF: 'SELF'
};

module.exports = Object.freeze(ItemRelationshipType);